import { defineComponent as _defineComponent } from 'vue'
import type { StreamingChartTitle } from './types';

import StreamingChartsListItem from '@/components/streaming-charts/StreamingChartsListItem.vue';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { computed } from 'vue';

interface StreamingChartsListProps {
	titles: StreamingChartTitle[];
	totalTitles: number | undefined;
	lastUpdated?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'StreamingChartsList',
  props: {
    titles: null,
    totalTitles: null,
    lastUpdated: null
  },
  setup(__props: any) {

const props = __props as { titles: StreamingChartTitle[], totalTitles: number | undefined, lastUpdated?: string };



const { country, language } = useLanguageStore();

const updatedTimestamp = computed(() => {
	if (!props.lastUpdated) {
		return null;
	}
	const date = new Date(props.lastUpdated).toLocaleDateString(`${language}-${country}`, {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	});
	const time = new Date(props.lastUpdated).toLocaleTimeString(`${language}-${country}`);
	return `${time}, ${date}`;
});

return { __sfc: true,props, country, language, updatedTimestamp, StreamingChartsListItem }
}

})